import React, { useState, useEffect } from "react";
import { CDBBtn } from 'cdbreact';
import Select from "react-select";

const months = [
  { label: 'Enero', value: 1 },
  { label: 'Febrero', value: 2 },
  { label: 'Marzo', value: 3 },
  { label: 'Abril', value: 4 },
  { label: 'Mayo', value: 5 },
  { label: 'Junio', value: 6 },
  { label: 'Julio', value: 7 },
  { label: 'Agosto', value: 8 },
  { label: 'Septiembre', value: 9 },
  { label: 'Octubre', value: 10 },
  { label: 'Noviembre', value: 11 },
  { label: 'Diciembre', value: 12 },
];

export const ModalProviders = ({
    action,
    setPressedButton,
    formData,
    handleChange,
    setFormData,
  }) => {
  
    const currentYear = new Date().getFullYear();
    const nextTenYears = Array.from({ length: 10 }, (_, index) => 2023 + index);

    const yearSelect = nextTenYears.map((year) => ({
      label: year.toString(),
      value: year,
    }));

    return (
      <div>
         <div className="modal-header">
            <div>
              <h3 className="modal-title" id="exampleModalLabel">
                {action === 'monthlyReport' ? 'Reporte Proveedores Mensual' : 'Reporte Proveedor Mensual'}
              </h3>
            </div>
          </div>
        <div className="modal-body">
          <div className="form-group row mb-4">
            <div className="col">
                <label htmlFor="selectedYear">Seleccione el año <span className="text-danger"> *</span></label>
                <Select
                  id="selectedYear"
                  placeholder="Año"
                  options={yearSelect}
                  value={yearSelect.find(option => option.value === formData.selectedYear)}
                  onChange={(selectedOption) =>
                    handleChange({
                      target: {
                        value: selectedOption.value.toString(),
                        id: "selectedYear",
                      },
                    })
                  }
                />
              </div>
          </div>
          <div className="form-group row mb-4">
          <div className="col">
            <label htmlFor="selectedMonth">Seleccione el mes <span className="text-danger"> *</span></label>
            <Select
              id="selectedMonth"
              placeholder="Mes"
              options={months}
              value={months.find(option => option.value === formData.selectedMonth)}
              onChange={(selectedOption) =>
                handleChange({
                  target: {
                    value: selectedOption.value.toString(),
                    id: "selectedMonth",
                  },
                })
              }
            />
          </div>
          </div>
        </div>
        <div className="modal-footer justify-content-center align-items-center">
          <CDBBtn
            type="button"
            color="danger"
            outline
            onClick={() => setPressedButton('closeModal')}
          >
            Cerrar
          </CDBBtn>
          <CDBBtn
            type="button"
            color="primary"
            className="mr-auto"
            outline
            onClick={() => setPressedButton('submitModal')}
          >
            Descargar
          </CDBBtn>
        </div>
      </div>
    );
  };